import MajorList from "./StatisticalPagePopup";
import ReviewIcon from "@material-ui/icons/PostAddOutlined";

export default {
  icon: ReviewIcon,
  list: MajorList,
  name: "statistical",
};
